import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "new",
  "use": "new-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"new\">\n<path d=\"M17.5,9H11V2.5C11,2.224,10.776,2,10.5,2h-1\n\tC9.224,2,9,2.224,9,2.5V9H2.5C2.224,9,2,9.224,2,9.5v1C2,10.776,2.224,11,2.5,11H9v6.5C9,17.776,9.224,18,9.5,18h1\n\tc0.276,0,0.5-0.224,0.5-0.5V11h6.5c0.276,0,0.5-0.224,0.5-0.5v-1C18,9.224,17.776,9,17.5,9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol